import {
    CircularProgress,
    Button,
    Typography,  
    IconButton,   
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import { Close } from '@mui/icons-material';

const GenericDialog = ({
    open,
    onClose,
    title,
    loading,
    children,
}) => {

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            sx={{ '& .MuiDialog-paper': { minWidth: { xs: '96%', md: '50%' } } }}
        >
            <DialogTitle >
                <Typography fontWeight="bold" color="primary.main">
                    {title}
                </Typography>
                
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.neutral.dark,
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {loading ? <CircularProgress /> : children}
            </DialogContent>

            <DialogActions>
                <Button 
                    variant="outlined" 
                    color="secondary"
                    onClick={onClose} 
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default GenericDialog;